import React, { useState } from 'react'

import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components'
import { Text } from '@hhgtech/hhg-components/mantine'
import { Box } from '@mantine/core'
import { motion } from 'framer-motion'
import { useIntl } from 'react-intl'

import { useIsMobile } from 'hooks/useIsMobile'
import { assetImagePath, assetSvgPath } from 'interfaces/constants'

const StyledWrap = styled.div`
  padding-bottom: 1.5rem;
  margin-bottom: 1.5rem;
  margin-top: auto;

  &[data-bordered='true'] {
    border-bottom: 1px solid ${theme.colors.neutral100};
  }
  &[data-bordered='false'] {
    padding-bottom: 0;
    margin-bottom: 0;
  }

  ${MediaQueries.mbDown} {
    &[data-bordered='true'] {
      padding-top: 1.5rem;
    }
  }

  .ht-disclaimer {
    gap: 8px;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }
  .ht-disclaimer-desc {
    color: #595959;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    text-transform: uppercase;
  }
  .ht-disclaimer-down {
    color: black;
  }

  .ht-disclaimer-expanded {
    font-size: 12px;
    color: #595959;
    line-height: 1.4;
    padding-top: 8px;
    overflow: hidden;
  }

  .ht-disclaimer-info-svg {
    transition: all 0.3s ease;
    &[data-show='true'] {
      transform: rotateZ(180deg);
    }
  }
`

const DueDateDisclaimer = ({
  description,
  bordered = true,
}: {
  description: string
  bordered?: boolean
}) => {
  const [isShow, setIsShow] = useState(true)
  const { formatMessage: f } = useIntl()
  const isMobile = useIsMobile()

  return (
    <StyledWrap data-bordered={String(!!bordered)}>
      <Box className="ht-disclaimer" onClick={() => setIsShow(!isShow)}>
        <img
          src={`${assetImagePath}/info-icon.svg`}
          alt=""
          loading="lazy"
          className="ht-disclaimer-info-svg"
          style={{ width: 18, height: 18 }}
        />
        <Text
          size={isMobile ? 'c1' : 'c2'}
          weight="semiBold"
          color={theme.colors.gray600}
          transform="uppercase"
          span
        >
          {f({ id: 'dueDatePage.disclaimer' })}
        </Text>
        <img
          src={`${assetSvgPath}/arrow-down.svg`}
          alt=""
          loading="lazy"
          className="ht-disclaimer-info-svg"
          data-show={isShow}
        />
      </Box>
      <motion.div
        animate={isShow ? { height: 'auto' } : { height: 0 }}
        transition={{ duration: 0.3 }}
        style={{ overflow: 'hidden' }}
      >
        <Text
          size="c2"
          color={theme.colors.gray600}
          span
          style={{ marginTop: 8 }}
        >
          {description}
        </Text>
      </motion.div>
    </StyledWrap>
  )
}

export default DueDateDisclaimer
